import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['track', 'slide', 'dot']

  connect () {
    this.onScroll = () => this.scheduleSync()
    this.trackTarget.addEventListener('scroll', this.onScroll, { passive: true })
    this.sync()
  }

  disconnect () {
    this.trackTarget.removeEventListener('scroll', this.onScroll)
    if (this.frame) cancelAnimationFrame(this.frame)
  }

  go (event) {
    const slide = this.slideTargets[this.clamp(Number(event.currentTarget.dataset.index))]

    slide?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
  }

  // Private

  scheduleSync () {
    if (this.frame) return

    this.frame = requestAnimationFrame(() => {
      this.frame = null
      this.sync()
    })
  }

  sync () {
    const width = this.trackTarget.clientWidth
    const index = width > 0 ? this.clamp(Math.round(this.trackTarget.scrollLeft / width)) : 0

    this.dotTargets.forEach((dot, i) => {
      const active = i === index

      dot.classList.toggle('w-6', active)
      dot.classList.toggle('bg-gray-800', active)
      dot.classList.toggle('w-2', !active)
      dot.classList.toggle('bg-gray-300', !active)
    })
  }

  clamp (index) {
    return Math.max(0, Math.min(index, this.slideTargets.length - 1))
  }
}
